import { render, staticRenderFns } from "./color-palette.vue?vue&type=template&id=20157a14&scoped=true&"
import script from "./color-palette.vue?vue&type=script&lang=js&"
export * from "./color-palette.vue?vue&type=script&lang=js&"
import style0 from "./color-palette.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./color-palette.vue?vue&type=style&index=1&id=20157a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20157a14",
  null
  
)

export default component.exports